/*
 * Centralised map of native JCC Form Builder template IDs (Production).
 * Single source of truth for every Drive-link → native-form swap across
 * ShiftKitSection, CarerStarterHub, FamilyCircleHub and
 * proCarerCircleContent — never hard-code a template_id in a component.
 * Sourced from the live Production GET /api/admin/forms response
 * (2026-09-01). Preview template IDs must never appear here.
 */
export const NATIVE_FORM_IDS = {
  ARRIVAL_CHECK: "966615de-341f-4318-8e89-6cfb48942766",
  DAILY_CARE_LOG: "pilot-daily-care-log",
  DAILY_MEDICATION_RECORD: "75bfadb9-c5f3-4cd6-b1a0-d26d1e91471e",
  HANDOVER_NOTES: "d382dab5-1325-4514-b63c-d4b8d99f968e",
  FOOD_FLUID_CHART: "1ad9dbaa-aa55-4ce4-b197-2c945d61bcbc",
  MOOD_BEHAVIOUR_NOTES: "4d3b6138-d74b-4553-b52d-907249094481",
  MOBILITY_TRANSFERS: "c8fe0ff3-c78d-4cc8-9359-ca67f1bb88bc",
  INCIDENT_REPORT: "c3b0a9a5-5d96-4034-a2b0-a72b28b55afc",
  NEAR_MISS_REPORT: "e325fb2b-a254-492c-987c-732d661e3f68",
  SAFEGUARDING_CONCERN: "b5093a7c-6e9a-411a-a22f-ddbc65a8e218",
  EMERGENCY_ESCALATION: "51c1fe65-aaf7-442c-897c-474b6a215481",
  END_OF_SHIFT_SUMMARY: "886aa261-fc9a-4d72-9ec3-321036229749",
  WEEKLY_SUMMARY: "71c99553-e89a-4b88-ad39-f3d1c1cfa1b7",
  CARE_PLAN_AGREEMENT: "b0b3c02c-f401-4ae9-854b-fd20a41055a6",
  CANCELLATION_POLICY: "07b722ba-00cc-4676-acda-ef716f17c9b7",
  BASIC_SERVICE_AGREEMENT: "2b1aaf9a-bfa6-4aa0-ad0f-42a47fe3c4ce",
  SIMPLE_INVOICE_TEMPLATE: "56301885-eabe-4bca-96c2-051b0c4a3e46",
  DAILY_CARE_NOTES: "cdaf07ae-bf7f-44f3-9dd6-1bc96b7d7044",
  BASIC_EMERGENCY_INFO_FORM: "823778c9-6c5f-42ab-9c05-5922af4d778a",
  SELF_EMPLOYED_CHECKLIST: "4d3576f8-d94f-4e73-b26e-f67bb44ba2b6",
  CARE_BOOKING_AGREEMENT: "e1859d8a-1cbe-4abe-87a6-8b561fcc95ae",
  // Responsible Payer Confirmation — now shared across family_circle and
  // pro_carer in Production (confirmed 2026-09-21), wired into
  // PAYMENT_ITEMS in proCarerCircleContent.jsx.
  RESPONSIBLE_PAYER_CONFIRMATION: "ccb108e6-877e-4d3b-a26e-5a2064e6682c",
  DEPOSIT_PAYMENT_AGREEMENT: "1293fd1e-2088-47cb-b6d4-640a996f1103",
  CARE_SCHEDULE_EXPECTATIONS: "f7c6ea27-4214-4829-aa01-88f6a9c1f6ee",
  CHANGE_OF_CARE_TERMS: "a95deda3-09db-440d-89f5-97e686347316",
  CPD_TRACKER: "53583d25-c10c-42cd-8196-383b1413ed37",
};

export const nativeFormPath = (templateId) => `/forms/${templateId}`;
